import React, {useState} from 'react'
import Navbar from './components/navbar/Navbar.jsx'
import Home from './components/home/Home'
import Brainstorming from './components/brainstorming/Brainstorming'
import './style/main.scss'
import Landing from './components/landing/Landing'
import Session from "./components/session/Session"
import YourSession from './components/yourSession/YourSession'
import SessionsPage from './components/sessionsPage/SessionsPage'
import MoreDetails from './components/moreDetails/MoreDetails'
import Mobile from './components/mobile/Mobile'
import TeamMembers from './components/teamMembers/teamMembers.jsx'

const pages = ['landing', 'brainstorming','more' ,'yourSession', 'session','landing']
function App() {
  const [page, setPage] = useState('landing') 
  const nextPage = (add) => { 
    setPage(pages[pages.indexOf(page) + add ]) 
  }
  // const handleButtonClick = ()=> { 
  //   const audio = new Audio(aud)

  //   audio.play()
  //   setTimeout(() => {
  //       audio.pause()
  //   }, 500);
  // }
  const handleChangePage = (pageName) => { 
    setPage(pageName)
  }
  return (<> 
    <div className="app">

    {page !== 'session'? <> 
    <Navbar changePage={handleChangePage} />

    <div style={{width:'400px'}}></div>

    <Home>
      {page === 'landing'? <Landing nextPage={nextPage} />: "" }
      {page === 'brainstorming'? <Brainstorming nextPage={nextPage} />: "" }
      {page === 'more'? <MoreDetails nextPage={nextPage} />: "" }
      {page === 'yourSession'? <YourSession nextPage={nextPage} />: "" }
      {page === 'teamMembers'? <TeamMembers nextPage={nextPage} />: "" }
    </Home>
    </>: 
 <SessionsPage nextPage={nextPage} pagesLength={pages.length}/> 
 }

    </div>
    <Mobile /> 
    </>
  );
}

export default App;
